













import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ErrorBag, FieldBag } from 'vee-validate';

@Component({
    inject: ['$validator']
})
export default class FieldComponent extends Vue {
    @Prop() public control: { label: string; key: string };

    @Prop() public loading: boolean;

    public fields: FieldBag; // already injected by vee-validate, here only for types

    public errors: ErrorBag; // already injected by vee-validate, here only for types

    get isRequired(): boolean {
        const field = this.fields[this.control.key];
        if (!field) {
            return false;
        }
        return field.required;
    }
}
